import {
  ApptPatientInfoInput,
  useQueuedAppointmentPatientInfo,
} from './CubicleQueueHooks';

type IPatientInfoRowProps = ApptPatientInfoInput;

export const PatientInfoRow = (props: IPatientInfoRowProps) => {
  const { textValue } = useQueuedAppointmentPatientInfo(props);
  return <>{textValue}</>;
};
